const loadImage = (src: string) => {
  return new Promise<HTMLImageElement>((resolve, reject) => {
    const img = new Image();
    img.onload = (event: any) => resolve(event.target);
    img.onerror = reject;
    img.src = src;
  });
};

const imageHelper = {
  loadImage,
};

export default imageHelper;
